import { z } from 'zod';
import { type EntitlementName, entitlementNameSchema } from './EntitlementNames';

export const subscriptionFamilySchema = z.enum(['unlimited', 'early_access']);
export type SubscriptionFamily = z.infer<typeof subscriptionFamilySchema>;

const entitlementFamilies: Partial<Record<EntitlementName, SubscriptionFamily>> = {
  gtv_unlimited: 'unlimited',
  unlimited: 'unlimited',
  subscription: 'unlimited',
  with_ads: 'unlimited',
  unlimited_with_ads: 'unlimited',
  unlimited_app_bundle: 'unlimited',
  textonly: 'unlimited',
  audioonly: 'unlimited',
  gtv_early_access: 'early_access',
};

export const getSubscriptionFamilyForEntitlement = (entitlement: EntitlementName): SubscriptionFamily | null =>
  entitlementFamilies[entitlement] ?? null;

export const subscriptionBillingPeriodSchema = z.enum(['weekly', 'monthly', 'yearly']);
export type SubscriptionBillingPeriod = z.infer<typeof subscriptionBillingPeriodSchema>;

export const providerSubscriptionMetadataSchema = z
  .object({
    entitlement: entitlementNameSchema,
    family: subscriptionFamilySchema,
    billingPeriod: subscriptionBillingPeriodSchema,
  })
  .superRefine(({ entitlement, family }, context) => {
    if (getSubscriptionFamilyForEntitlement(entitlement) !== family) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Entitlement ${entitlement} does not belong to subscription family ${family}`,
        path: ['family'],
      });
    }
  });
export type ProviderSubscriptionMetadata = z.infer<typeof providerSubscriptionMetadataSchema>;
